
define('unknown/views/pwResetView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/pwResetModel',
], function($, _, Backbone, PwResetModel){
	var PwResetFooterView = Backbone.View.extend({
		events: {
			'click #pwResetFormSubmit': 'submitPwResetForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'saving', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showNonForm);
		},
		
		submitPwResetForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#pwResetFormSubmitt").show();
		},
		
		showNonForm: function () {
			this.$("#pwResetFormSubmitt").hide();
		},
	});

	var PwResetContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.pwResetModel = options.pwResetModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'formEnter');
			
			$('#pwResetBodyContentForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'save', this.submitPwReset);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'success', this.success);
			
			//Error handling
			this.listenTo(this.event, 'error:username', this.errorUsername);
		},
		
		submitPwReset: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				
				this.pwResetModel.save({
					userName: this.$("#pwResetUserNameInput").val()
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}			
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#pwResetBodyContentForm").hide();
			this.$("#pwResetBodyContentProcessing").hide();
			this.$("#pwResetBodyContentSuccess").hide();
			
			//Hide error messages
			this.$("#pwResetUserNameGrp").removeClass("error");
			this.$("#pwResetUserNameInput").removeClass("error");
			this.$("#pwResetUserNameErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyContentSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyContentProcessing").show();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyContentForm").show();
		},
		
		errorUsername : function (errorCode) {
			this.$("#pwResetUserNameGrp").addClass("error");
			this.$("#pwResetUserNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#pwResetUserNameErrMsg").html("Username is empty");
					this.$("#pwResetUserNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#pwResetUserNameErrMsg").html("Username must be between 5 and 20 characters long");
					this.$("#pwResetUserNameErrMsg").show();
					break;
				case "ALPHANUM": 
					this.$("#pwResetUserNameErrMsg").html("Username may only contain alpha numeric characters");
					this.$("#pwResetUserNameErrMsg").show();
					break;
				case "USERNOTEXIST": 
					this.$("#pwResetUserNameErrMsg").html("User doesn't exist");
					this.$("#pwResetUserNameErrMsg").show();
					break;
				default : 
					this.$("#pwResetUserNameErrMsg").html("Username is invalid");
			}
		},
	});

	var PwResetMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#pwResetBodyMessageError").hide();
			this.$("#pwResetBodyMessageProcessing").hide();
			this.$("#pwResetBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#pwResetBodyMessageProcessing").show();
		},
	});
	
	var PwResetView = Backbone.View.extend({
		el: $("#pwResetContent"),
		
		initialize: function(options) {
			this.pwResetModel = options.pwResetModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};			
			
			this.message = new PwResetMessageView({el: this.$("#pwResetBodyMessage"), event: this.event});
			this.content = new PwResetContentView({
				el: this.$("#pwResetBodyContent"), 
				event: this.event, 
				pwResetModel: this.pwResetModel,
				submittedData: this.submittedData});
			this.footer = new PwResetFooterView({el: this.$("#pwResetFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.resetSuccess);
			this.listenTo(this.event, 'savingError', this.resetError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		resetError: function(model, error) {		
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 404) {
					this.event.trigger("error");
					this.event.trigger("error:username", "USERNOTEXIST");
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		resetSuccess: function () {
			this.submittedData.isSubmitted = false;
			this.event.trigger("success");
		},
	});
	
	return PwResetView;  
});